import { Alert } from 'react-bootstrap';

export function NeedProject({ message }: { message?: string }) {
  return (
    <Alert variant="light" className="border">
      <div className="fw-semibold mb-1">پروژه‌ای انتخاب نشده</div>
      <p className="mb-0 text-secondary">
        {message ??
          'همه تنظیمات، درخواست‌ها و نتایج روی پروژه ذخیره می‌شوند. از منوی بالا یک پروژه انتخاب کنید.'}
      </p>
    </Alert>
  );
}
